import axios from "axios";
import { GetApiResponse } from "../types/api";
import { IPCScore } from "../types/ipcScore";
import Cookies from "js-cookie";
import { apiV1BaseUrl } from "./index";

const accessToken = () => Cookies.get("accessToken");

export const getIpcScoreFeatureAndGroup = async ({
  country,
  aggregationLevel,
  geographicalUnit,
  type,
}: {
  country: string;
  aggregationLevel: string;
  geographicalUnit: string;
  type: string;
}) => {
  try {
    const response = await axios.get<GetApiResponse<IPCScore>>(
      `${apiV1BaseUrl}/timeseries/IpcScores`,
      {
        params: {
          country,
          adminLevel: aggregationLevel,
          geounit: geographicalUnit,
          type,
        },
        ...(type === "user"
          ? {
              headers: {
                ...(accessToken()
                  ? { Authorization: `Bearer ${accessToken()}` }
                  : {}),
              },
            }
          : {}),
      },
    );

    return response.data;
  } catch (error) {
    throw error;
  }
};
